import { render } from "./CommitmentAssigneePicker.vue?vue&type=template&id=773d8c31&scoped=true"
import script from "./CommitmentAssigneePicker.vue?vue&type=script&lang=js"
export * from "./CommitmentAssigneePicker.vue?vue&type=script&lang=js"

import "./CommitmentAssigneePicker.vue?vue&type=style&index=0&id=773d8c31&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-773d8c31"

export default script